import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { AccessInboxPageComponent } from './components/page/access-inbox-page.component';
import { AccessInboxRoutingModule } from './access-inbox-routing.module';
import { MatIconModule } from '@angular/material/icon';
import { Angulartics2Module } from 'angulartics2';
import { ScanGMailButtonModule } from '../shared/scan-gmail-button/scan-gmail-button.module';

@NgModule({
  declarations: [
	  AccessInboxPageComponent,
  ],
  imports: [
    CommonModule,
    AccessInboxRoutingModule,
    MatGridListModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    SharedModule,
    MatIconModule,
    Angulartics2Module,
    ScanGMailButtonModule,
    NgOptimizedImage
  ]
})
export class AccessInboxModule { }
